const SHOWN_KEY = 'jc-sign-in-save-nudge-shown-session';
const DISMISSED_KEY = 'jc-sign-in-save-nudge-dismissed-session';

/**
 * Whether we should open the sign-in prompt after a guest successfully saved a job locally.
 * At most one prompt per browser session until the user dismisses the modal (see {@link markSignInSaveNudgeDismissedThisSession}).
 */
export function shouldOpenSignInPromptAfterGuestSave(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  if (sessionStorage.getItem(DISMISSED_KEY) === '1') {
    return false;
  }
  if (sessionStorage.getItem(SHOWN_KEY) === '1') {
    return false;
  }
  sessionStorage.setItem(SHOWN_KEY, '1');
  return true;
}

/** Call when the user dismisses the sign-in prompt without signing in (snooze for this session). */
export function markSignInSaveNudgeDismissedThisSession(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(DISMISSED_KEY, '1');
}
